import moment from 'moment'
import qrcode from 'qrcode'
import FiscalData from './FiscalData'

const state = () => ({})

const getters = {
  business: state => prop => null,
  ticketInfo: state => null,
  invoiceInfo: state => null,
  fiscalInfo: (state, getters, rootState) => [
    { title: 'developmentEntity', value: ['Revo Systems, S.L.', 'B66353780'] },
    { title: 'softwareName', value: 'Revo XEF (Handy)' },
    { title: 'serialNumber', value: rootState.UUID },
    { title: 'responsibilityDeclaration', type: 'url', value: 'https://www.cegid.com/ib/wp-content/uploads/sites/3/2025/07/CegidRevoXef_Declaracion-responsable-VeriFactu.pdf' },
  ],
  fiscalData: (state, getters, rootState, rootGetters) => rootGetters['fiscalCountry/test']
    ? null
    : new FiscalData(rootGetters['fiscalCountry/config']()),
  orderMaxAmount: (state, getters, rootState, rootGetters) => rootGetters['fiscalCountry/spain/orderMaxAmount'],

  contentPrice: state => payload => null,
  shouldAddReason: state => null,
  shouldSignInvoice: state => false,
}

const mutations = {}

const actions = {
  async printPreHeader ({ dispatch }, { order, invoice }) {
    if (invoice?.accountable) {
      await dispatch('_printQR', invoice)
    }
  },
  printAdditionalHeader ({}, business) {},
  printAdditionalFooter ({}, business) {},
  printCheckSummary ({ dispatch }, order) {
    return dispatch('fiscalCountry/spain/printCheckSummary', order, { root: true })
  },
  printInvoiceSummary ({ dispatch }, { order, invoice }) {
    return dispatch('fiscalCountry/spain/printInvoiceSummary', { order, invoice }, { root: true })
  },
  signPrintCheck ({}, { order, reason }) {},
  signInvoice ({}, invoice) {},
  async _printQR ({ state, getters, dispatch, rootGetters }, invoice) {
    if (rootGetters['fiscalCountry/test']) {
      return
    }
    const host = window.$vm.$page.props.production ? 'www2.agenciatributaria.gob.es' : 'prewww2.aeat.es'
    const endpoint = invoice.fiscal_data.veriFactu ? 'ValidarQR' : 'ValidarQRNoVerifactu'
    const qs = new URLSearchParams({
      nif: getters['fiscalData'].nif ?? '',
      numserie: invoice.number,
      fecha: moment(invoice.date).format('DD-MM-YYYY'),
      importe: invoice.total.toFixed(2),
    })
    const url = `https://${host}/wlpl/TIKE-CONT/${endpoint}?` + qs.toString()

    AndroidPrinter.text(rootGetters['translate']('taxQR'))
    try {
      AndroidPrinter.image64(await qrcode.toDataURL(url, {
        errorCorrectionLevel: 'M',
        margin: 2,
      }))
    } catch (err) {
      dispatch('log', { action: 'Cannot print the invoice QR: ' + err, model: 'Order', model_id: invoice.order_id }, { root: true })
      dispatch('alert/showError', rootGetters['translate']('printError'), { root: true })
    }
    if (invoice.fiscal_data.veriFactu) {
      AndroidPrinter.text('VERI*FACTU')
    }
    AndroidPrinter.separator('-')
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
